import { Flex, Icon, Spacing } from '@billy/design-system'
import cc from 'classcat'
import React, { useCallback, useState } from 'react'

import { reactClass } from '../../utils'
import * as Styled from './styles'

export type FlipperProps = {
  children?: React.ReactNode
  className?: string
  onFlipSide?: () => void
}

export const Flipper = ({ children, className, onFlipSide = () => null }: FlipperProps) => {
  const [side, setSide] = useState<number>(0)

  const handleFlipSide = useCallback(() => {
    setSide((prevSide) => (prevSide + 1) % 2)
    onFlipSide()
  }, [onFlipSide])

  return (
    <Styled.FlipperContainer className={cc([className, reactClass('flipper')])}>
      <Flex gap={Spacing.S8}>
        <Flex width="100%">
          {React.Children.map(
            children as React.ReactNode[],
            (child: React.ReactNode, index: number): JSX.Element | null =>
              React.isValidElement(child) && index === side ? React.cloneElement(child, {}) : null,
          )}
        </Flex>

        {side ? (
          <Icon icon="chevronUp" onClick={handleFlipSide} size="lg" />
        ) : (
          <Icon icon="chevronDown" onClick={handleFlipSide} size="lg" />
        )}
      </Flex>
    </Styled.FlipperContainer>
  )
}
